module.exports = __webpack_public_path__ + "static/media/ranger_bow.e69838e3.png";